import { useState, useEffect, useRef } from 'react';

const stats = [
  {
    icon: 'ri-user-heart-line',
    value: '50+',
    label: 'Clients Coached',
  },
  {
    icon: 'ri-map-pin-2-line',
    value: 'Lubbock',
    label: 'Texas Based',
  },
  {
    icon: 'ri-star-line',
    value: '5-Star',
    label: 'Client Reviews',
  },
  {
    icon: 'ri-gift-line',
    value: '100%',
    label: 'Free First Consultation',
  },
  {
    icon: 'ri-focus-3-line',
    value: 'Goal-Focused',
    label: 'Every Session',
  },
];

export default function StatsBar() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-[#2D3E2E] py-0">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 divide-x divide-white/10">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`flex flex-col items-center justify-center gap-2 py-8 px-4 text-center transition-all duration-600 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              } ${i === 4 ? 'col-span-2 sm:col-span-1' : ''}`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 mb-1">
                <i className={`${stat.icon} text-[#D4896A] text-xl`} />
              </div>
              <span
                className="text-xl md:text-2xl font-bold text-white leading-none"
                style={{ fontFamily: '\'Playfair Display\', serif' }}
              >
                {stat.value}
              </span>
              <span
                className="text-xs text-[#A8B5A0] tracking-wide uppercase font-medium"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
